import Swiper, { Navigation, Pagination, Thumbs, Grid, Autoplay } from 'swiper';

function observeOnce(el, cb, rootMargin = '200px 0px') {
    if (!el || el.dataset.swiperObserved === '1') {
        return;
    }
    el.dataset.swiperObserved = '1';

    if (!('IntersectionObserver' in window)) {
        cb();
        return;
    }

    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                io.disconnect();
                cb();
            }
        });
    }, { rootMargin, threshold: 0.01 });

    io.observe(el);
}

function initSwiper(selector, options, root = document) {
    root.querySelectorAll(selector).forEach((el) => {
        observeOnce(el, () => new Swiper(el, options));
    });
}

initSwiper('.main-blog-swiper', {
    modules: [Pagination, Navigation, Grid],
    slidesPerView: 4,
    spaceBetween: 10,
    grabCursor: true,
    autoHeight: true,
    slideActiveClass: 'main-blog-slider-active',
});

initSwiper('.catalog-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 5,
    autoplay: { delay: 5000 },
    spaceBetween: 10,
    grabCursor: true,
    navigation: {
        nextEl: '.catalog-swiper .swiper-button-next',
        prevEl: '.catalog-swiper .swiper-button-prev',
    },
    breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        576: { slidesPerView: 2, spaceBetween: 20 },
        992: { slidesPerView: 3, spaceBetween: 20 },
        1200: { slidesPerView: 4, spaceBetween: 30 },
        1400: { slidesPerView: 5, spaceBetween: 40 },
    },
});

initSwiper('.product-history-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 1,
    loop: true,
    autoplay: { delay: 5000 },
    spaceBetween: 10,
    grabCursor: true,
    breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        576: { slidesPerView: 2, spaceBetween: 20 },
        992: { slidesPerView: 3, spaceBetween: 20 },
        1200: { slidesPerView: 4, spaceBetween: 30 },
        1400: { slidesPerView: 4, spaceBetween: 40 },
    },
});

document.querySelectorAll('.slider__thumbs .swiper-container').forEach((thumbsEl) => {
    observeOnce(thumbsEl, () => {
        const sliderThumbs = new Swiper(thumbsEl, {
            modules: [Pagination, Navigation, Grid, Autoplay, Thumbs],
            direction: 'vertical',
            slidesPerView: 5,
            spaceBetween: 24,
            freeMode: true,
            breakpoints: {
                0: { direction: 'horizontal', slidesPerView: 2 },
                768: { direction: 'vertical', slidesPerView: 3 },
                1200: { slidesPerView: 4 },
                1400: { slidesPerView: 5 },
            },
        });

        const imagesRoot = thumbsEl.closest('.slider__thumbs')?.parentElement;
        const imagesEl = imagesRoot?.querySelector('.slider__images .swiper-container');
        if (imagesEl) {
            observeOnce(imagesEl, () => {
                new Swiper(imagesEl, {
                    modules: [Pagination, Navigation, Grid, Autoplay, Thumbs],
                    slidesPerView: 1,
                    spaceBetween: 32,
                    mousewheel: true,
                    grabCursor: true,
                    thumbs: { swiper: sliderThumbs },
                });
            });
        }
    });
});

initSwiper('.section-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 5,
    autoplay: { delay: 5000 },
    loop: true,
    spaceBetween: 10,
    grabCursor: true,
    breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        576: { slidesPerView: 2, spaceBetween: 20 },
        992: { slidesPerView: 3, spaceBetween: 20 },
        1200: { slidesPerView: 4, spaceBetween: 30 },
        1400: { slidesPerView: 5, spaceBetween: 40 },
    },
});

initSwiper('.documentation-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 4,
    autoplay: { delay: 5000 },
    spaceBetween: 10,
    grabCursor: true,
    breakpoints: {
        320: { slidesPerView: 1.3, spaceBetween: 10 },
        576: { slidesPerView: 2, spaceBetween: 20 },
        992: { slidesPerView: 3, spaceBetween: 20 },
        1200: { slidesPerView: 4, spaceBetween: 30 },
        1400: { slidesPerView: 4, spaceBetween: 40 },
    },
});

initSwiper('.home-reviews-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 1.3,
    spaceBetween: 10,
    grabCursor: true,
    watchOverflow: true,
    resistanceRatio: 0.85,
    breakpoints: {
        768: { slidesPerView: 2.4, spaceBetween: 40 },
    },
});

initSwiper('.home-advantages-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 1.55,
    spaceBetween: 0,
    grabCursor: true,
    watchOverflow: true,
    breakpoints: {
        768: { slidesPerView: 4, spaceBetween: 0 },
    },
});

initSwiper('.advantages-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 4,
    autoplay: { delay: 5000 },
    spaceBetween: 10,
    grabCursor: true,
    navigation: {
        nextEl: '.advantages-buttons .advantages-button-next',
        prevEl: '.advantages-buttons .advantages-button-prev',
    },
    breakpoints: {
        320: { slidesPerView: 1.3, spaceBetween: 10 },
        576: { slidesPerView: 2, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: 10 },
        992: { slidesPerView: 3, spaceBetween: 10 },
        1200: { slidesPerView: 3, spaceBetween: 10 },
        1400: { slidesPerView: 4, spaceBetween: 20 },
    },
});

initSwiper('.swiper-improvement', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 2,
    autoplay: { delay: 3000 },
    spaceBetween: 30,
    grabCursor: true,
});

initSwiper('.comfort-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 1.3,
    autoplay: { delay: 5000 },
    spaceBetween: 30,
    grabCursor: true,
    breakpoints: {
        320: { slidesPerView: 1.3, spaceBetween: 10 },
        1200: { slidesPerView: 2, spaceBetween: 20 },
        1600: { slidesPerView: 2, spaceBetween: 40 },
        1700: { slidesPerView: 2, spaceBetween: 50 },
        1800: { slidesPerView: 2, spaceBetween: 60 },
    },
});

initSwiper('.dynamic-swiper', {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 1,
    autoplay: { delay: 5000 },
    navigation: {
        nextEl: '.dynamic-swiper .custom-swiper-button-next',
        prevEl: '.dynamic-swiper .custom-swiper-button-prev',
    },
    grabCursor: true,
});

document.querySelectorAll('.developer-gallery-swiper').forEach((el) => {
    if (el.querySelectorAll('.swiper-slide').length < 2) {
        return;
    }
    observeOnce(el, () => {
        new Swiper(el, {
            modules: [Navigation, Autoplay],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            grabCursor: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: el.querySelector('.developer-gallery__nav--next'),
                prevEl: el.querySelector('.developer-gallery__nav--prev'),
            },
        });
    });
});

document.querySelectorAll('.schastie-develop-swiper').forEach((el) => {
    if (el.querySelectorAll('.swiper-slide').length < 2) {
        return;
    }
    observeOnce(el, () => {
        new Swiper(el, {
            modules: [Autoplay],
            slidesPerView: 1.15,
            spaceBetween: 16,
            loop: true,
            grabCursor: true,
            autoplay: { delay: 4000, disableOnInteraction: false },
            breakpoints: {
                768: { slidesPerView: 1.2, spaceBetween: 24 },
                1200: { slidesPerView: 1.2, spaceBetween: 40 },
            },
        });
    });
});

document.querySelectorAll('[data-schastie-develop]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-develop-tab]')];
    const panels = [...root.querySelectorAll('[data-develop-panel]')];
    if (tabs.length < 2 || panels.length < 2) {
        return;
    }

    let auto = true;
    let index = 0;
    let timer = null;

    const show = (nextIndex) => {
        index = (nextIndex + panels.length) % panels.length;
        tabs.forEach((tab, i) => {
            const active = i === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel, i) => {
            panel.classList.toggle('is-active', i === index);
        });
    };

    const startAuto = () => {
        clearInterval(timer);
        if (!auto) {
            return;
        }
        timer = setInterval(() => show(index + 1), 4000);
    };

    tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
            auto = false;
            clearInterval(timer);
            show(i);
        });
    });

    show(0);
    startAuto();
});
